import React, { Component } from "react";

const _loaded = {};
class ImageLoader extends Component {
  static defaultProps = {
    className: "",
    loadingClassName: "loading",
    loadedClassName: "loaded",
    onLoadChange: () => { },
    action: null // add default
  };

  constructor(props, context) {
    super(props, context);
    this.state = { loaded: _loaded[props.src] || false };
  }

  onLoad = () => {
    _loaded[this.props.src] = true;
    this.setState({ loaded: true }, () => {
      this.props.onLoadChange(true); // notify parent
    });
  };

  onClick = (event) => {
    const { action } = this.props;
    if (action && action.onClick) {
      action.onClick(event); // trigger passed action
    }
  };

  render() {
    let {
      className,
      loadedClassName,
      loadingClassName,
      onLoadChange,
      action,
      ...props
    } = this.props;

    className = `${className} ${this.state.loaded ? loadedClassName : loadingClassName
      }`;

    return (
      <img
        {...props}
        className={className}
        onLoad={this.onLoad}
        onClick={this.onClick}
        alt="item"
      />
    );
  }
}

export default ImageLoader;